import React, { FC } from 'react';
import { PaymentMethodError } from '..';
import css from './style.module.scss';

const ErrorMessage: FC<{ message: string }> = ({ message }) => {
  return <span className={css.error_msg}>{message}</span>;
};

export const PaymentMethodErrorMessage: FC<{
  errorType: PaymentMethodError;
}> = ({ errorType }) => {
  if (errorType === 'bad_request')
    return <ErrorMessage message="不正なリクエストです" />;
  if (errorType === 'invalid_voucher')
    return <ErrorMessage message="不正なクーポンです" />;
  if (errorType === 'invalid_voucher_type')
    return <ErrorMessage message="不正なクーポンタイプです" />;
  if (errorType === 'missing_customer_email')
    return (
      <ErrorMessage message="メールアドレスが登録されていないので使用できません。" />
    );
  if (errorType === 'unverified')
    return (
      <ErrorMessage message="この店舗では使用できないお支払い方法です。" />
    );
  if (errorType === 'not_supported')
    return (
      <ErrorMessage message="このお支払い方法はサポートされていません。" />
    );
  if (errorType === 'limit_exceeded_subscription')
    return (
      <ErrorMessage message="この月謝で設定されている予約回数の上限に達しているため、使用できません。" />
    );
  if (errorType === 'limit_exceeded_ticket')
    return (
      <ErrorMessage message="この回数券で設定されている予約回数の上限に達しているため、使用できません。" />
    );
  if (errorType === 'consumed')
    return (
      <ErrorMessage message="使用済みなので、今回のお支払い方法では選択できません。" />
    );
  if (errorType === 'login_required')
    return (
      <ErrorMessage message="このお支払い方法を使用するためにはログインする必要があります。" />
    );
  if (errorType === 'not_found')
    return <ErrorMessage message="このお支払い方法は見つかりませんでした。" />;
  if (errorType === 'not_first_time_reservation')
    return (
      <ErrorMessage message="このお支払い方法は初回予約でのみ使用可能です。" />
    );
  if (errorType === 'required')
    return <ErrorMessage message="お支払い方法を選択してください。" />;
  if (errorType === 'ticket_not_available_on_selected_date')
    return (
      <ErrorMessage message="有効期限を超えた日付が選択されているため利用できません。" />
    );
  if (errorType) return <ErrorMessage message="エラーが発生しました。" />;

  return null;
};
